import script from "./ViewMode.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewMode.vue?vue&type=script&setup=true&lang=js"

import "./ViewMode.vue?vue&type=style&index=0&id=3ec30268&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ec30268"]])

export default __exports__